import { Injectable, signal } from '@angular/core';

/**
 * The values every page prints and no page owns: what money is called, what language the head
 * declares, what year the footer claims.
 *
 * Signals rather than constants because none of this is settled. unimarket-api sent all three
 * on every page until recently, and they were hardcoded there too - the currency next to a TODO
 * saying so. The day a shop needs its own, this is the only file that changes: no template moves,
 * because a template already reads them the way it would read anything else that can change.
 */
@Injectable({ providedIn: 'root' })
export class StorefrontContext {

  readonly currency = signal('грн.').asReadonly();

  readonly locale = signal('ua').asReadonly();

  /** Read once, which on the server means once per rendered request. */
  readonly year = signal(String(new Date().getFullYear())).asReadonly();

}
